/**
 * scanParam — le QR pare-brise ouvre `…/?scan=<jeton>`.
 *
 * Le paramètre est lu UNE fois, au chargement du bundle, puis retiré de la barre d'adresse :
 * un rechargement ne doit pas rejouer le scan, et le jeton n'a rien à faire dans l'historique.
 * Il est gardé en `sessionStorage` le temps de la connexion — un conducteur pas encore
 * connecté scanne, se connecte, et arrive quand même sur le bon véhicule.
 *
 * Aucune décision ici : le serveur relit et vérifie le jeton (`/drivers/me/pool/scan/:token`).
 */

export const SCAN_STORAGE_KEY = 'fm_pending_scan';
const TOKEN_SHAPE = /^v1\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/;

const storage = (win) => {
  try { return win.sessionStorage; } catch { return null; }
};

/** À appeler au chargement : range le jeton de l'URL et nettoie l'adresse. Rend le jeton ou null. */
export function captureScanParam(win = typeof window !== 'undefined' ? window : null) {
  if (!win?.location) return null;
  const params = new URLSearchParams(win.location.search || '');
  const token = params.get('scan');
  if (!token) return null;
  params.delete('scan');
  const rest = params.toString();
  try {
    win.history?.replaceState(null, '', `${win.location.pathname}${rest ? `?${rest}` : ''}${win.location.hash || ''}`);
  } catch { /* adresse laissée telle quelle : sans conséquence */ }
  if (!TOKEN_SHAPE.test(token)) return null;
  try { storage(win)?.setItem(SCAN_STORAGE_KEY, token); } catch { /* navigation privée stricte */ }
  return token;
}

/** Le jeton en attente, consommé : une seule ouverture par scan. */
export function takePendingScan(win = typeof window !== 'undefined' ? window : null) {
  const store = win ? storage(win) : null;
  if (!store) return null;
  try {
    const token = store.getItem(SCAN_STORAGE_KEY);
    store.removeItem(SCAN_STORAGE_KEY);
    return token && TOKEN_SHAPE.test(token) ? token : null;
  } catch {
    return null;
  }
}
